module.exports = __webpack_public_path__ + "img/1678419208028-foajAi-F.2e3315eb.png";